"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHorizontalScroll = exports.useScrollToRightOnLoad = exports.useGraphSize = void 0;
var react_1 = require("react");
var useBreakpoint_1 = require("../../hooks/useBreakpoint");
function useGraphSize(usagePeriods, isSnapshot) {
    var isMobile = (0, useBreakpoint_1.useBreakpoint)().isMobile;
    var usagePeriodData = (0, react_1.useMemo)(function () { return usagePeriods.map(function (x) { var _a, _b; return (_b = (_a = x.usage) === null || _a === void 0 ? void 0 : _a.cost) !== null && _b !== void 0 ? _b : 0; }); }, [usagePeriods]);
    var solarPeriodData = (0, react_1.useMemo)(function () { return usagePeriods.map(function (x) { var _a, _b; return (_b = (_a = x.solar) === null || _a === void 0 ? void 0 : _a.cost) !== null && _b !== void 0 ? _b : 0; }); }, [usagePeriods]);
    var maxGraphValue = Math.max.apply(Math, usagePeriodData);
    var maxGraphSolarValue = Math.max.apply(Math, solarPeriodData);
    var maxValue = Math.max(maxGraphValue, maxGraphSolarValue);
    var ceilValue = maxValue < 100 ? (maxValue < 10 ? 1 : 10) : 100;
    var maxY = Math.ceil(maxValue / ceilValue) * ceilValue;
    var findYAxisValue = function (highestDataValue) { return (maxY / 2.0 >= highestDataValue ? maxY / 2 : maxY); };
    var graphYAxisValue = findYAxisValue(maxGraphValue);
    var graphSolarYAxisValue = findYAxisValue(maxGraphSolarValue);
    var numOfColumns = usagePeriods.length;
    var barThicknessLarge = 28;
    var barThicknessSmall = 20;
    var barThickness = isMobile ? barThicknessSmall : barThicknessLarge;
    var minChartPxWidth = "".concat(numOfColumns * (barThicknessSmall * 2.5), "px");
    return {
        graphYAxisValue: graphYAxisValue,
        graphSolarYAxisValue: graphSolarYAxisValue,
        graphIsSmall: !isSnapshot && graphYAxisValue < graphSolarYAxisValue,
        graphSolarIsSmall: !isSnapshot && graphSolarYAxisValue < graphYAxisValue,
        usagePeriodData: usagePeriodData,
        solarPeriodData: solarPeriodData,
        barThickness: barThickness,
        minChartPxWidth: minChartPxWidth,
        numOfColumns: numOfColumns,
        graphEqualSize: isSnapshot || graphSolarYAxisValue === graphYAxisValue,
    };
}
exports.useGraphSize = useGraphSize;
function useScrollToRightOnLoad(containerRef) {
    (0, react_1.useLayoutEffect)(function () {
        var _a, _b;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width });
    }, []);
}
exports.useScrollToRightOnLoad = useScrollToRightOnLoad;
function useHorizontalScroll(scrollDivRef) {
    (0, react_1.useLayoutEffect)(function () {
        var callback = function (event) {
            var element = scrollDivRef.current;
            if (!element) {
                return;
            }
            var overflows = element.scrollWidth > element.clientWidth;
            if (!overflows) {
                return;
            }
            var isDown = event.deltaY > 0;
            element.scrollLeft += isDown ? 20 : -20;
            event.preventDefault();
        };
        var scrollDiv = scrollDivRef.current;
        scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.addEventListener('wheel', callback);
        return function () {
            scrollDiv === null || scrollDiv === void 0 ? void 0 : scrollDiv.removeEventListener('wheel', callback);
        };
    }, [scrollDivRef]);
}
exports.useHorizontalScroll = useHorizontalScroll;
//# sourceMappingURL=UsageGraph.hooks.js.map